import { ChevronLeft, ChevronRight } from "lucide-react";

export const Pagination = ({ page, totalPages, onChange, testidPrefix = "pagination" }) => {
  if (totalPages <= 1) return null;
  const btnBase =
    "flex h-11 min-w-11 items-center justify-center border px-3 text-[12px] font-semibold tracking-[0.15em] transition-all duration-300";
  const arrowCls = `${btnBase} gap-1.5 border-white/15 uppercase text-[#A3A3A3] hover:border-gold hover:text-gold disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:border-white/15 disabled:hover:text-[#A3A3A3]`;
  return (
    <nav
      data-testid={`${testidPrefix}-pagination`}
      aria-label="Navigasi halaman"
      className="mt-14 flex flex-wrap items-center justify-center gap-2"
    >
      <button
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        data-testid={`${testidPrefix}-pagination-prev`}
        aria-label="Halaman sebelumnya"
        className={arrowCls}
      >
        <ChevronLeft size={15} /> Prev
      </button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          onClick={() => onChange(n)}
          data-testid={`${testidPrefix}-pagination-page-${n}`}
          aria-label={`Halaman ${n}`}
          aria-current={n === page ? "page" : undefined}
          className={`${btnBase} ${
            n === page
              ? "border-gold bg-gold text-ink"
              : "border-white/15 text-[#A3A3A3] hover:border-gold hover:text-gold"
          }`}
        >
          {String(n).padStart(2, "0")}
        </button>
      ))}
      <button
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        data-testid={`${testidPrefix}-pagination-next`}
        aria-label="Halaman berikutnya"
        className={arrowCls}
      >
        Next <ChevronRight size={15} />
      </button>
      <p
        data-testid={`${testidPrefix}-pagination-info`}
        className="mt-4 w-full text-center text-[11px] font-medium uppercase tracking-[0.25em] text-[#737373]"
      >
        Halaman {page} dari {totalPages}
      </p>
    </nav>
  );
};
